export default __webpack_public_path__ + "assets/images/c8976a5412ff9b89998aff20a55bae11.png";